import documentsServices from "../../../../services/api/service/documentService";
import losServices from "../../../../services/api/service/losService";
import { RelationWithStudentList } from "../../../../data/constant";
import { mapGender } from "../../../../utils/helpers";
import { setStatusPopup } from "../../../../services/redux/slices/statusPopupSlice";

const buildEmpSaveFormData = ({
    coApplicantNumbers,
    updatedCoApplicantFields,
    values,
  }: { 
    coApplicantNumbers: number;
    updatedCoApplicantFields: any;
    values: any
  }) => {
    return [
      {
      formFieldId: updatedCoApplicantFields.find((field: any) =>
            field.name.includes(
              `employmentCoApplicant${coApplicantNumbers}isEmployed`
            )
      )?.id,
      fieldKey: `employmentCoApplicant${coApplicantNumbers}isEmployed`,
      fieldValue: values[`employmentCoApplicant${coApplicantNumbers}isEmployed`],
    },
    {
      formFieldId: updatedCoApplicantFields.find((field: any) =>
            field.name.includes(
              `employmentCoApplicant${coApplicantNumbers}employmentType`
            )
      )?.id,
      fieldKey: `employmentCoApplicant${coApplicantNumbers}employmentType`,
      fieldValue: values[`employmentCoApplicant${coApplicantNumbers}employmentType`],
    }, 
  ]
}

export async function submitCoApplicant({
  values,
  setSubmitting,
  updatedCoApplicantFields,
  respCoApplicantFieldsIds,
  getCoApplicantNumbers,
  applicationNumber,
  aadhaarSeedingStatus,
  isCoApplicantPanVerified,
  SalutationList,
  relationshipList,
  fetchUserApplicationData,
  applicationId,
  dispatch,
  handleFetchApplicationDetail,
  handleDeleteCoApplicantFields,
  closeCoApplicantModal,
}: {
  values: any;
  setSubmitting: any;
  updatedCoApplicantFields: any;
  respCoApplicantFieldsIds: any;
  getCoApplicantNumbers: number;
  applicationNumber: any;
  aadhaarSeedingStatus: string;
  isCoApplicantPanVerified: boolean;
  SalutationList: { value: string; label: string }[];
  relationshipList?: { value: string; label: string }[];
  fetchUserApplicationData: any;
  applicationId?: string;
  dispatch: any;
  handleFetchApplicationDetail: () => void;
  handleDeleteCoApplicantFields: (payload: any) => Promise<void>;
  closeCoApplicantModal: () => void;
}) {
  try {
    let mobileNumber = "";
    let email = "";
    let coApplicantType = "";

    const coApplicantNumbers = getCoApplicantNumbers;

    const transformFormData = (formValues: any) => {
      const formData: any[] = [];

      const fieldConfig: { [key: string]: { apiKey: string; formFieldId: number } } =
      {
        OtherRelationWithStudent: {
          apiKey: `basicCoApplicant${coApplicantNumbers + 1}OtherRelationWithStudent`,
          formFieldId: updatedCoApplicantFields.find((field: any) =>
            field.name.includes(
              `basicCoApplicant${coApplicantNumbers + 1}OtherRelationWithStudent`
            )
          )?.id,
        },
        RelationWithStudent: {
          apiKey: `basicCoApplicant${coApplicantNumbers + 1}RelationWithStudent`,
          formFieldId: updatedCoApplicantFields.find((field: any) =>
            field.name.includes(
              `basicCoApplicant${coApplicantNumbers + 1}RelationWithStudent`
            )
          )?.id,
        },
        Salutation: {
          apiKey: `basicCoApplicant${coApplicantNumbers + 1}salutation`,
          formFieldId: updatedCoApplicantFields.find((field: any) =>
            field?.name?.includes(`basicCoApplicant${coApplicantNumbers + 1}salutation`)
          )?.id,
        },
        FirstName: {
          apiKey: `basicCoApplicant${coApplicantNumbers + 1}FirstName`,
          formFieldId: updatedCoApplicantFields.find((field: any) =>
            field.name.includes(`basicCoApplicant${coApplicantNumbers + 1}FirstName`)
          )?.id,
        },
        LastName: {
          apiKey: `basicCoApplicant${coApplicantNumbers + 1}LastName`,
          formFieldId: updatedCoApplicantFields.find((field: any) =>
            field.name.includes(`basicCoApplicant${coApplicantNumbers + 1}LastName`)
          )?.id,
        },
        PanNumber: {
          apiKey: `basicCoApplicant${coApplicantNumbers + 1}PanNumber`,
          formFieldId: updatedCoApplicantFields.find((field: any) =>
            field.name.includes(`basicCoApplicant${coApplicantNumbers + 1}PanNumber`)
          )?.id,
        },
        Email: {
          apiKey: `basicCoApplicant${coApplicantNumbers + 1}Email`,
          formFieldId: updatedCoApplicantFields.find((field: any) =>
            field.name.includes(`basicCoApplicant${coApplicantNumbers + 1}Email`)
          )?.id,
        },
        PhoneNumber: {
          apiKey: `basicCoApplicant${coApplicantNumbers + 1}PhoneNumber`,
          formFieldId: updatedCoApplicantFields.find((field: any) =>
            field.name.includes(
              `basicCoApplicant${coApplicantNumbers + 1}PhoneNumber`
            )
          )?.id,
        },
        dob: {
          apiKey: `basicCoApplicant${coApplicantNumbers + 1}dob`,
          formFieldId: updatedCoApplicantFields.find((field: any) =>
            field.name.includes(`basicCoApplicant${coApplicantNumbers + 1}dob`)
          )?.id,
        },
        Gender: {
          apiKey: `basicCoApplicant${coApplicantNumbers + 1}Gender`,
          formFieldId: updatedCoApplicantFields.find((field: any) =>
            field.name.includes(`basicCoApplicant${coApplicantNumbers + 1}Gender`)
          )?.id,
        },
      };

      Object.entries(formValues).forEach(([formKey, formValue]) => {
        if (
          formKey.includes("IsMobileVerified") ||
          formKey.includes("IsEmailVerified")
        ) {
          return;
        }

        const fieldName = formKey.replace(
          `basicCoApplicant${coApplicantNumbers + 1}`,
          ""
        );
        let config = fieldConfig[fieldName];

        if (!config) {
          const matchingKey = Object.keys(fieldConfig).find(
            (key) =>
              fieldName.toLowerCase().includes(key.toLowerCase()) ||
              key.toLowerCase().includes(fieldName.toLowerCase())
          );
          if (matchingKey) {
            config = fieldConfig[matchingKey];
          }
        }

        if (fieldName.includes("salutation")) {
          formValue =
            SalutationList.find((salutation: any) => salutation.label === formValue)
              ?.value || "";
        }

        if (
          config &&
          formValue !== null &&
          formValue !== undefined &&
          formValue !== ""
        ) {
          const valueToStore =
            fieldName.includes("Email") && typeof formValue === "string"
              ? formValue.trim().toLowerCase()
              : formValue;
          formData.push({
            formFieldId: config.formFieldId,
            fieldKey: config.apiKey,
            fieldValue: valueToStore,
          });
        }
      });

      formData.push({
        formFieldId: updatedCoApplicantFields.find((field: any) =>
          field.name.includes(`basicCoApplicant${coApplicantNumbers + 1}IsPanVerified`)
        )?.id,
        fieldKey: `basicCoApplicant${coApplicantNumbers + 1}IsPanVerified`,
        fieldValue: isCoApplicantPanVerified,
      });
      formData.push({
        formFieldId: updatedCoApplicantFields.find((field: any) =>
          field.name.includes(`basicCoApplicant${coApplicantNumbers + 1}IsMobileVerified`)
        )?.id,
        fieldKey: `basicCoApplicant${coApplicantNumbers + 1}IsMobileVerified`,
        fieldValue: Boolean(
          formValues[`basicCoApplicant${coApplicantNumbers + 1}IsMobileVerified`]
        ),
      });
      formData.push({
        formFieldId: updatedCoApplicantFields.find((field: any) =>
          field.name.includes(`basicCoApplicant${coApplicantNumbers + 1}IsEmailVerified`)
        )?.id,
        fieldKey: `basicCoApplicant${coApplicantNumbers + 1}IsEmailVerified`,
        fieldValue: Boolean(
          formValues[`basicCoApplicant${coApplicantNumbers + 1}IsEmailVerified`]
        ),
      });
      if(coApplicantNumbers + 1 === 1) {
        formData.push({
          formFieldId: updatedCoApplicantFields.find((field: any) =>
            field.name.includes(`basicCoApplicant${coApplicantNumbers + 1}PayParty`)
          )?.id,
          fieldKey: `basicCoApplicant${coApplicantNumbers + 1}PayParty`,
          fieldValue: "Yes",
        });
      } else if(coApplicantNumbers + 1 > 1) {
        formData.push({
          formFieldId: updatedCoApplicantFields.find((field: any) =>
            field.name.includes(`basicCoApplicant${coApplicantNumbers + 1}PayParty`)
          )?.id,
          fieldKey: `basicCoApplicant${coApplicantNumbers + 1}PayParty`,
          fieldValue: formValues[`basicCoApplicant${coApplicantNumbers + 1}PayParty`],
        });
      }

      mobileNumber =
        formValues[`basicCoApplicant${coApplicantNumbers + 1}PhoneNumber`];
      const rawEmail = formValues[`basicCoApplicant${coApplicantNumbers + 1}Email`];
      email =
        rawEmail != null && rawEmail !== ""
          ? String(rawEmail).trim().toLowerCase()
          : "";
      coApplicantType = `Co-Applicant ${coApplicantNumbers + 1}`;

      return formData;
    };

    const transformedData = transformFormData(values);
    const coAppNum = coApplicantNumbers + 1;
    const trackingId = String(applicationNumber);
    const coApplicantMobileVerified = Boolean(
      values[`basicCoApplicant${coAppNum}IsMobileVerified`]
    );
    const coApplicantEmailVerified = Boolean(
      values[`basicCoApplicant${coAppNum}IsEmailVerified`]
    );

    const relationshipOptionsListFallback = RelationWithStudentList?.map(
      (rel: string) => ({ value: rel, label: rel })
    );
    const relationshipOptionsList: { value: string; label: string }[] =
      ((relationshipList?.length ?? 0) > 0 && relationshipList
        ? relationshipList
        : relationshipOptionsListFallback) ?? relationshipOptionsListFallback;


    const saveEmpFormData = buildEmpSaveFormData({
        coApplicantNumbers: coAppNum,
        updatedCoApplicantFields,
        values
    })
    await documentsServices
      .saveCoApplicantDocument({
        trackingId,
        mobileNumber,
        email,
        coApplicantType,
        formData: [...transformedData, ...saveEmpFormData],
        isAadhaarSeeded: aadhaarSeedingStatus === "y" ? true : false,
        section: "basic"
      })
      .then(async (resp: any) => {
        closeCoApplicantModal();
        handleFetchApplicationDetail();
        dispatch(
          setStatusPopup({
            status: "success",
            message: resp?.data?.message,
          })
        );
      })
      .catch(async (err: any) => {

        if (respCoApplicantFieldsIds.length > 0) {
          const payload = {
            trackingId,
            form_field_ids: respCoApplicantFieldsIds,
          };
          await handleDeleteCoApplicantFields(payload);
        }

        setSubmitting(false);
        dispatch(
          setStatusPopup({
            status: "error",
            message: err?.response?.data?.message,
          })
        );
      });
  } catch (error: any) {
    dispatch(
      setStatusPopup({
        status: "error",
        message: error?.response?.data?.message || "Error submitting co-applicant",
      })
    );
  } finally {
    setSubmitting(false);
  }
}
